module.exports = __webpack_public_path__ + "static/media/ic-close.5280631e.svg";